import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

interface FaqItem {
  question: string;
  answer: string;
}

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  standalone: false
})
export class FaqComponent implements OnInit {
  faqItems: FaqItem[] = [
    {
      question: '¿Puedo cambiar de plan en cualquier momento?',
      answer: 'Sí, puedes actualizar o degradar tu plan en cualquier momento. Los cambios se aplicarán al inicio del siguiente ciclo de facturación.'
    },
    {
      question: '¿Qué sucede si supero el límite de interacciones de mi plan?',
      answer: 'Si superas el límite de interacciones, se te cobrará una tarifa adicional por cada interacción extra. También te notificaremos para que consideres actualizar a un plan superior si esto ocurre regularmente.'
    },
    {
      question: '¿Ofrecen descuentos para organizaciones sin fines de lucro o instituciones educativas?',
      answer: 'Sí, contamos con programas especiales para organizaciones sin fines de lucro, instituciones educativas y startups. Contacta a nuestro equipo de ventas para más información.'
    },
    {
      question: '¿Cuánto tiempo toma implementar Zapphira.ai en mi sitio web?',
      answer: 'La implementación básica puede realizarse en menos de 1 hora. Para integraciones más complejas o personalizaciones avanzadas, nuestro equipo trabajará contigo para establecer un cronograma adecuado.'
    },
    {
      question: '¿Es necesario tener conocimientos técnicos para implementar Zapphira.ai?',
      answer: 'No, hemos diseñado Zapphira.ai para ser extremadamente sencillo de implementar. Ofrecemos un widget de integración con código simple para copiar y pegar, y nuestro equipo de soporte técnico está disponible para ayudarte en el proceso.'
    },
    {
      question: '¿Puedo personalizar las respuestas del chatbot según mis necesidades?',
      answer: 'Absolutamente. Zapphira.ai te permite configurar y personalizar las respuestas para adaptarlas a tu marca y a las necesidades específicas de tu negocio. Puedes crear flujos de conversación personalizados, entrenar al bot con información específica de tu empresa y ajustar el tono de comunicación.'
    }
  ];

  activeIndex: number = 0;

  constructor() { }

  ngOnInit(): void {
    // Inicializamos con el primer ítem abierto por defecto
  }

  toggleFaq(index: number): void {
    if (this.activeIndex === index) {
      // Si hacemos clic en el elemento ya activo, lo cerramos
      this.activeIndex = -1;
    } else {
      // De lo contrario, activamos el nuevo elemento
      this.activeIndex = index;
    }
  }
}